<template>
  <el-dialog
    :title="$t('lang.导出信息')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="5.74rem"
    :before-close="handleClose"
  >
    <div class="down_bg">
        <p class="tipsday">{{ $t("lang.导出记录只保存7天") }}</p>
      <div class="export_record _row_between">
        <p class="font14">
          {{ $t("lang.导出记录") }}({{ $t("lang.总数") }}:{{ totalItemCount }})
        </p>
        <el-button type="primary" size="small" @click="iRecordFetch">{{
          $t("lang.刷新")
        }}</el-button>
      </div>
      <el-table
        :data="dataList"
        height="300"
        style="width: 100%"
        :header-cell-style="{ backgroundColor: '#eeeeee' }"
      >
        <el-table-column
          :label="$t('lang.序号')"
          align="left"
          type="index"
          width="130"
        >
        </el-table-column>
        <el-table-column
          v-for="(item, index) of tableTitle"
          :key="index"
          :prop="item.prop"
          :width="item.width"
          :show-overflow-tooltip="true"
          :label="$t('lang.' + item.label)"
          :align="item.align"
        >
          <template slot-scope="scope">
            <div v-if="item.prop == 'startTime' || item.prop == 'endTime'">
              <span>{{
                scope.row[item.prop] | timeFormat("YYYY-MM-DD HH:mm:ss")
              }}</span>
            </div>
            <div v-else-if="item.prop == 'status'">
              <el-progress
                type="circle"
                :percentage="
                  scope.row[item.prop] == 0 ? scope.row['progress'] : 100
                "
                :width="40"
                :status="
                  scope.row[item.prop] == 0
                    ? null
                    : scope.row[item.prop] == 1
                    ? 'success'
                    : 'exception'
                "
                style="padding: 10px"
              ></el-progress>
            </div>
            <div v-else-if="item.prop == 'remark'">
              <span>{{
                scope.row.status == 0 ? $t("lang.导出中") : scope.row[item.prop]
              }}</span>
            </div>
            <div v-else>
              <span>{{ scope.row[item.prop] || "--" }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.操作')" align="left" min-width="160" fixed="right">
          <template slot-scope="scope">
            <div class="_row">
              <a
                :class="[
                  scope.row.status == 3 || scope.row.status == 0
                    ? 'errorState'
                    : 'successState',
                ]"
                :href="getHref(scope.row)"
                download="ssss.xls"
                :disabled="false"
                v-if="scope.row.filePath"
                >{{ $t("lang.下载") }}</a
              >
              <span class="errorState" v-else>{{ $t("lang.下载") }}</span>
              <a style="color: rgb(21, 122, 255); margin: 0 5px">|</a>
              <a
                style="color: rgb(21, 122, 255); cursor: pointer"
                @click="onClickDel(scope.row)"
                >{{ $t("lang.删除") }}</a
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { titleList } from "./titleList";
export default {
  data() {
    return {
      dialogVisible: false,
      dataList: [],
      tableTitle: titleList,
      totalItemCount: 0,
      timer: null,
    };
  },
  mounted() {},
  computed: {
    ...mapGetters(["downloadDialogShow"]),
  },
  watch: {
    downloadDialogShow(newVal) {
      this.dialogVisible = newVal;
    },
    dialogVisible(val) {
      if (val) {
        this.iRecordFetch();
        return;
      }
      this.clearFetch();
    },
  },
  methods: {
    ...mapMutations(["showDownload"]),
    ...mapActions({
      recordFetch: "ZD_RecordFetch",
      recordDelete: "ZD_RecordDelete",
    }),
    handleClose(done) {
      this.showDownload();
    },
    getHref(row) {
      if (row.status == 3 || row.status == 0) return null;
      return row.filePath;
    },
    //#region 获取导出列表
    async iRecordFetch() {
      try {
        let res = await this.recordFetch({});
        if (res.success !== 1 || this.isnull(res.listitem)) throw new Error("");
        res.listitem.forEach((item) => {
          item.progress = 0;
          if (item.remark == undefined) item.remark = this.$t("lang.导出成功");
        });
        this.dataList = res.listitem;
        this.totalItemCount = res.totalItemCount;
        if (res.listitem[0].status != 0) {
          this.clearFetch();
        } else {
          if (this.isnull(this.timer)) this.setFetch();
        }
      } catch (e) {
        this.dataList = [];
        this.totalItemCount = 0;
        clearInterval(this.timer);
      }
    },
    setFetch() {
      this.clearFetch();
      this.timer = setInterval(() => {
        this.iRecordFetch();
      }, 1000);
    },
    clearFetch() {
      if (this.isnull(this.timer)) return;
      clearInterval(this.timer);
      this.timer = null;
    },
    //#endregion

    async onClickDel(row) {
      await this.$confirm(
        this.$t("lang.您是否确认要删除"),
        this.$t("lang.提示"),
        {
          confirmButtonText: this.$t("lang.确认"),
          cancelButtonText: this.$t("lang.取消"),
          type: "warning",
        }
      );
      let res = await this.recordDelete({ id: row.id });
      if (res.success !== 1) return;
      this.$message.success(this.$t("lang.删除成功"));
      this.iRecordFetch();
    },
  },
};
</script>

<style lang="less" scoped>
.successState {
  color: rgb(21, 122, 255);
  cursor: pointer;
}
.errorState {
  color: #c4c4c4;
  cursor: not-allowed;
}

.down_bg {
  width: 902px;
  margin: 0 auto;
  padding-bottom: 20px;
  .tipsday{
    display: inline-block;
    font-size: 14px;
    line-height: 14px;
    color: #333;
    padding: 10px 12px;
    background-color: #FBE1E1;
    border-radius: 4px;
  }
  .export_record {
    height: 56px;
    width: 100%;
  }
}
</style>